import { useStore } from '../store';

import type { UiAdvisorNote as AdvisorNote } from '../advisors';

function NoteRow({ note, advisorTitle }: { note: AdvisorNote; advisorTitle: string }) {
  const warn = note.severity === 'warn';
  return (
    <div class="card" style="border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:8px;padding:10px 12px;display:flex;gap:10px;align-items:flex-start">
      <span
        aria-label={warn ? 'warning' : 'info'}
        style={`flex:none;width:10px;height:10px;border-radius:50%;margin-top:4px;background:${warn ? 'var(--ui-amber, #b97a2a)' : 'var(--ui-ink-soft, #8a8378)'}`}
      />
      <span style="flex:1">
        <div class="row-label">{advisorTitle}</div>
        <div class="row-value" style="font-size:13px;font-weight:400;white-space:normal;line-height:1.35">{note.text}</div>
      </span>
    </div>
  );
}

export function AdvisorsPanel() {
  const { sim, bridge } = useStore();
  const proj = sim.advisors;
  const advisors = proj?.advisors ?? [];
  const notes = proj?.notes ?? [];
  const visible = notes.filter((n) => !advisors.find((a) => a.id === n.advisor)?.muted);
  const warns = visible.filter((n) => n.severity === 'warn');
  const infos = visible.filter((n) => n.severity === 'info');
  const titleOf = (id: string) => advisors.find((a) => a.id === id)?.title ?? id;

  return (
    <div style="padding:6px 14px 16px">
      <div class="eyebrow eyebrow-rule">Advisors</div>

      {proj === null && (
        <p style="font-size:13px;color:var(--ui-ink-soft);margin-top:8px">
          This worker has not provided advisor status. No all-clear is implied.
        </p>
      )}

      {warns.length > 0 && (
        <>
          <div class="row-label" style="margin-top:12px">Needs attention</div>
          {warns.map((n) => <NoteRow key={n.id} note={n} advisorTitle={titleOf(n.advisor)} />)}
        </>
      )}
      {infos.length > 0 && (
        <>
          <div class="row-label" style="margin-top:12px">Notes</div>
          {infos.map((n) => <NoteRow key={n.id} note={n} advisorTitle={titleOf(n.advisor)} />)}
        </>
      )}
      {proj !== null && visible.length === 0 && (
        <p style="font-size:13px;color:var(--ui-ink-soft);margin-top:8px">Nothing to flag right now.</p>
      )}

      {advisors.length > 0 && (
        <>
          <div class="row-label" style="margin-top:16px">Your advisors</div>
          {advisors.map((a) => (
            <div key={a.id} class="card row" style="border:var(--ui-border);background:var(--ui-parchment-soft);margin-top:8px">
              <span class="row-main">
                <div class="row-value">{a.title}</div>
                <div class="row-label" style="text-transform:none;letter-spacing:0.01em;white-space:normal">{a.covers}</div>
              </span>
              <button
                class="btn btn-quiet"
                style="padding:4px 10px;font-size:11px"
                aria-pressed={a.muted}
                onClick={() => { bridge.send('advisor.setMuted', { advisorId: a.id, muted: !a.muted }); }}
              >
                {a.muted ? 'Unmute' : 'Mute'}
              </button>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
